import axios from 'axios';
import { default401 } from './auth';
import { store } from '../store';

export const loadAgents = (params = {}) => {
  const { token } = store.getState().auth;
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/admins/search/`,
      method: 'get',
      headers: { Authorization: `Token ${token}` },
      params: {
        ...params,
        page: params.page,
      },
    }).then(({ data }) => {
      resolve(data);
    }).catch((err) => {
      reject(err);
    });
  });
};

export const getAgent = (username) => {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/agent/${username}/`,
    headers: { Authorization: `Token ${token}` },
  }).catch(default401);
};

export const getAgents = () => {
  const { token } = store.getState().auth;
  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/agent/`,
    headers: { Authorization: `Token ${token}` },
  }).then(({ data }) => {
    store.dispatch({ type: 'LOAD_AGENTS', users: data });
    return data;
  }).catch(default401);
};

export const createAgent = (agent) => {
  const { token } = store.getState().auth;

  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/agent/`,
    headers: { Authorization: `Token ${token}` },
    data: {
      ...agent,
      is_agent: true,
      first_login: true,
    },
  }).catch(default401)
    .catch((err) => {
      let id = 'other';
      let message = null;

      if (err.response) {
        if (err.response.status === 500 || err.response.status === 409) {
          if (err.response.data.error.includes('mmb_clients_user_email_site_id')) {
            id = 'email';
          } else if (err.response.data.error.includes('mmb_clients_user_npn')) {
            id = 'npn';
          }
        }
        message = `Bad response: ${err.response.status}`;
      } else if (err.request) {
        message = 'Server did not respond!';
      } else {
        message = `Unknown error: ${err.message}`;
      }
      store.dispatch({ type: 'EDIT_ADD_USER_VALIDATION', payload: { [id]: false } });
      store.dispatch({ type: 'ADD_USER_ERROR', id, message });
      throw new Error(`${id}: ${message}`);
    });
};

export const updateAgent = (username, details) => {
  const { token } = store.getState().auth;
  const agentEmail = store.getState().user.email;
  const {
    last_updated: lu,
    last_updated_by: lub,
    ...data
  } = details;

  const filteredData = Object.keys(data)
    .filter((detail) => detail !== 'site')
    // .filter((detail) => detail !== 'agency')
    .reduce((obj, key) => ({
      ...obj,
      [key]: data[key],
    }), {});

  return axios({
    method: 'put',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/agent/${username}/`,
    headers: { Authorization: `Token ${token}` },
    data: filteredData,
  }).then((res) => {
    if (details.email === agentEmail) {
      store.dispatch({ type: 'UPDATE_USER', payload: res.data.data });
    }
    store.dispatch({ type: 'UPDATE_AGENT', payload: res.data.data });
    store.dispatch({ type: 'SET_SELECTED_AGENT', agent: res.data.data });
    return res.data.data;
  }).catch(default401);
};

export const updateSelectedAgents = (conf) => {
  const { agents } = store.getState();
  // const selected = records.filter((agent) => agent.selected);

  const updates = agents.selectedAgents.map((agent) => updateAgent(agent.username, conf));
  return Promise.all(updates)
    .then(() => {
      store.dispatch({ type: 'SET_ACTIVE_STATUS', payload: conf.is_active });
    })
    .catch(default401);
};

export const changePassword = (data) => {
  const { token } = store.getState().auth;

  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/agent/change-password/`,
    headers: { Authorization: `Token ${token}` },
    data,
  }).catch(default401);
};

export function sendPasswordReset(email, linkback) {
  const { token } = store.getState().auth;
  return axios({
    method: 'get',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/password-reset/`,
    headers: { Authorization: `Token ${token}` },
    params: { email, linkback },
  }).catch(default401);
}

export function setTemporaryPassword({ username, temporaryPassword }) {
  const { token } = store.getState().auth;
  return axios({
    method: 'post',
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/set-temporary-password/`,
    headers: { Authorization: `Token ${token}` },
    data: {
      username,
      temporary_password: temporaryPassword,
    },
  }).catch(default401);
}
